// extracted by mini-css-extract-plugin
module.exports = {"content":"content___2HRb5","info":"info___1JTWF"};